import * as React from 'react';

import { Estimate } from 'src/api';
import { EstimateSummary } from './desktop/estimate-summary';
import { ViewMore, IViewMore } from 'src/core/components/view-more';
import { PresentationSettingsState } from '../../stores/estimate.store';

interface Props {
    estimate: Estimate;
    shouldShowApplyForFinancing: boolean;
    financingPresentationSetting?: PresentationSettingsState | undefined;
    gotoMobile: () => void;
}

export const EstimateSummaryContainer: React.SFC<Props> = ({
    estimate,
    shouldShowApplyForFinancing,
    financingPresentationSetting,
    gotoMobile,
}) => {
    const SummaryWrapper: React.FC<{ viewMore: IViewMore }> = ({ viewMore }) => (
        <EstimateSummary
            viewMore={viewMore}
            shouldShowApplyForFinancing={shouldShowApplyForFinancing}
            financingPresentationSetting={financingPresentationSetting}
            estimate={estimate}
            gotoMobile={gotoMobile}
        />
    );
    return (
        <ViewMore dangerouslySetInnerHTML={estimate.summarySanitized} component={SummaryWrapper} />
    );
};
